module.exports = __webpack_public_path__ + "static/media/2020.8.29未成年人随手捡助力创全.4694d733.jpg";